import { h } from 'preact'
import { Geografi, Parti, isGeografi, toNavType } from '../../../domain'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { Message } from '../../../../lib/intl/Message'
import { useLocale } from '../../../../lib/intl/IntlProvider'
import { getParentKey } from '../../shared/geografi'
import { NavLinks } from '../../shared/NavLinks/NavLinks'
import nabomap from '../../../../../assets/nabokommuner-map.json'

import styles from './Nabosider.css'
import { idFrom } from '../../../api'

type Props = {
  locale: string
  current: Geografi | Parti
  geografi: Geografi[]
}

function isSibling(current: Geografi) {
  const parent = getParentKey(current)

  return (sibling: Geografi) => {
    if (sibling.key === current.key) {
      return false
    }

    const siblingParent = getParentKey(sibling)
    return parent === siblingParent
  }
}

function titleKey(current: Geografi) {
  return 'nabosider-tittel-' + current.type.toLowerCase()
}

export function Nabosider(props: Props) {
  const { current, geografi } = props
  if (isGeografi(current) && current.type !== 'Nasjon') {
    let naboer = geografi.filter(isSibling(current))
    if (current.type === 'Kommune') {
      const nabokommuner = nabomap[idFrom(current)] || []
      naboer = geografi.filter(geo => nabokommuner.indexOf(idFrom(geo)) !== -1)
    }
    return (
      <section class={styles.nabosider} key={idFrom(current)}>
        <h3>
          <Message id={titleKey(current)} values={{ navn: current.navn }} />
        </h3>
        <NavLinks grunndata={naboer} sorter={true} type={toNavType(current)} />
      </section>
    )
  }
  return null
}

export function ConnectedNabosider() {
  const state = useAppState()
  const locale = useLocale()
  if (isGeografi(state.page.current)) {
    return (
      <Nabosider current={state.page.current} geografi={state.grunndata.geografi} locale={locale} />
    )
  }
  return null
}
